export const getAppointments = ({ technical }) => technical.appointments;
export const getTotalPages = ({ technical }) => technical.totalPages;
export const getCurrentPage = ({ technical }) => technical.currentPage;
export const getModalWindowStatus = ({ technical }) =>
  technical.modalWindowStatus;
export const getTechnicalError = ({ technical }) => technical.error;
export const getMessageTechnical = ({ technical }) => technical.message;
export const getErrorTechnical = ({ technical }) => technical.error;
export const getHeaderHeight = ({ technical }) => technical.headerHeight;
export const getAddHeaderHeight = ({ technical }) => technical.addHeaderHeight;
export const getCallButton = ({ technical }) => technical.callButton;
export const getEventsDates = ({ technical }) => technical.eventsDates;
export const getEvents = ({ technical }) => technical.events;
export const getLoadingTechnical = ({ technical }) => technical.loading;
export const getEditEvent = ({ technical }) => technical.editEvent;
export const getEditReview = ({ technical }) => technical.editReview;
export const getTotalPagesReview = ({ technical }) =>
  technical.totalPagesReview;
export const getReviews = ({ technical }) => technical.reviews;
export const getQA = ({ technical }) => technical.listQA;
export const getEditQA = ({ technical }) => technical.editQA;
